import { render } from "./Buttons.vue?vue&type=template&id=50301c8f"
import script from "./Buttons.vue?vue&type=script&lang=js"
export * from "./Buttons.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__